import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BlocPriseRendezVous({ ctx }) {
    const option = ctx.siteData.options.priseRendezVous;
    if (!option)
        return null;
    return (_jsxs("section", { className: "bloc prise-rendez-vous", children: [_jsx("h2", { children: ctx.l.priseRendezVous }), _jsx("p", { children: ctx.l.priseRendezVousPhrase }), _jsx("a", { href: `${option.lien}?lang=${ctx.langue}`, children: ctx.l.priseRendezVous })] }));
}
export function LienPresentation({ ctx, oeuvre }) {
    const option = ctx.siteData.options.priseRendezVous;
    if (!option?.oeuvres || oeuvre.statut !== 'disponible')
        return null;
    return (_jsx("p", { children: _jsx("a", { href: `${option.lien}?lang=${ctx.langue}&oeuvre=${encodeURIComponent(oeuvre.slug)}`, children: ctx.l.demanderPresentation }) }));
}
//# sourceMappingURL=site.js.map